import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, select, takeLatest, takeLeading } from "redux-saga/effects";
import { API_URL } from "utils/constants";
import { getDefaultHeaders } from "utils/helpers";
import { getPaginationMeta } from "utils/helpers/pagination";
import { request } from "utils/request";
import { AdminManagementListResponse, newUserForm } from "../types";
import { actions } from "./slice";
import {
  selectAdminManagementPage,
  selectAdminManagementPerPage,
  selectFormData,
} from "./selector";

let isFetchingList = false;

export function* handleGetUserList() {
  if (isFetchingList) return;
  isFetchingList = true;

  try {
    const page: number = yield select(selectAdminManagementPage);
    const perPage: number = yield select(selectAdminManagementPerPage);

    const response: AdminManagementListResponse = yield call(
      request,
      `${API_URL}/user?page=${page}&perPage=${perPage}`,
      { method: "GET", headers: getDefaultHeaders() }
    );

    const data = response?.data || [];
    const meta = getPaginationMeta(page, perPage, data, response?.meta);
    const payload = { data, meta };

    if (page === 1) {
      yield put(actions.getUserListSucsess(payload));
    } else {
      yield put(actions.getNextPageItemsSuccess(payload));
    }
  } catch (error) {
    const page: number = yield select(selectAdminManagementPage);
    if (page === 1) {
      yield put(actions.getUserListFailier((error as Error).message));
    } else {
      yield put(actions.getNextPageItemsFailure((error as Error).message));
    }
  } finally {
    isFetchingList = false;
  }
}

export function* addNewUser() {
  const formData: newUserForm = yield select(selectFormData);

  const options = {
    method: "POST",
    headers: getDefaultHeaders(),
    body: JSON.stringify(formData),
  };

  try {
    const response = yield call(request, `${API_URL}/user`, options);
    yield put(actions.addUserListSucsess(response.data));
  } catch (error) {
    yield put(actions.addUserListFailier());
  }
}

export function* handleGetUserDetailes(action: PayloadAction<string>) {
  try {
    const response = yield call(
      request,
      `${API_URL}/user/${action.payload}`,
      { method: "GET", headers: getDefaultHeaders() }
    );
    yield put(actions.getUserDetailesSucsess(response.data));
  } catch (error) {
    yield put(actions.getUserDetailesFailier((error as Error).message));
  }
}

export function* useUserManagementSaga() {
  yield takeLeading(actions.getUserList.type, handleGetUserList);
  yield takeLeading(actions.getNextPageItems.type, handleGetUserList);
  yield takeLatest(actions.addNewUser.type, addNewUser);
  yield takeLatest(actions.getUserDetailes.type, handleGetUserDetailes);
}